import Vue from 'vue'
import App from './App'
import router from './router'
import store from './sotre/index'
import axios from 'axios'
import ElementUI from 'element-ui'
import '../static/theme/blue/index.css'
import helper from './helper';

let Message = ElementUI.Message;

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.prototype.$http = axios;
Vue.prototype.$helper = helper;

// import 'element-ui/lib/theme-chalk/index.css'
// import '../static/theme/green/index.css'
import '../static/font-awesome/css/font-awesome.css'
import './assets/common.css'

router.beforeEach((to, from, next) => {
    if (to.meta.requireAuth) {
        if (store.getters.my) {
            if (to.meta.needPower) {
                let isPower = store.getters.my.is_master === 1;
                if (isPower) {
                    next();
                } else {
                    Message.error('权限拒绝');
                }
            } else {
                next();
            }
        } else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            });
        }
    } else {
        next();
    }
});

axios.defaults.baseURL = process.env.API_ROOT;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers.Authorization = 'Bearer ' + store.state.token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(
    response => {
        if (response.headers && (response.headers['content-type'] === 'application/x-msdownload' || response.headers['content-type'] === 'application/vnd.ms-excel'|| response.headers['content-type'] === 'application/vnd.openxmlformats')) {
            return response;
        }
        return response.data;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    let url = router.currentRoute.query.redirect ? router.currentRoute.query.redirect : router.currentRoute.fullPath;
                    store.commit('logout');
                    router.replace({
                        path: '/login',
                        query: {redirect: url}
                    });
            }
        }
        return Promise.reject(error.response.data);
    }
);

new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store
});



// WEBPACK FOOTER //
// ./src/main.js